/** @format */

import React, { useEffect } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";

import api from "../api/api";
import i18n from "../utils/i18n";

import { logout } from "../store/reducers/authReducer";
import {
  get_card_products,
  get_wishlists_products,
  reset_card,
} from "../store/reducers/cardReducers";
import { add_friend } from "../store/reducers/chatReducer";

import HeaderCategories from "./partialHeaders/HeaderCategories";
import HeaderMain from "./partialHeaders/HeaderMain";
import HeaderSearchBar from "./partialHeaders/HeaderSearchBar";
import HeaderSidebar from "./partialHeaders/HeaderSidebar";
import HeaderTop from "./partialHeaders/HeaderTop";

const Headers = ({ categories, clientLocation }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const { customerInfo } = useSelector((state) => state.auth);
  const { card_total, card_loading, wishList_count } = useSelector(
    (state) => state.card,
  );
  const { totalCustommerUnread } = useSelector((state) => state.chat);

  const [showSliderbar, setShowSliderbar] = React.useState(true);
  const [categoryShow, setCategoryShow] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState("");
  const [category, setCategory] = React.useState("");

  const handleSearch = () => {
    navigate(`/products/search?category=${category}&&value=${searchValue}`);
  };

  const handleLogout = () => {
    dispatch(reset_card()); // 🔥 reset panier
    dispatch(logout());
  };

  const redirect_to_card_page = () => {
    if (customerInfo) navigate(`/card`);
    else navigate("/login");
  };

  const redirect_to_wishlist_page = () => {
    if (customerInfo) navigate(`/dashboard/my_wishlist`);
    else navigate("/login");
  };

  const redirect_to_chat_page = () => {
    if (customerInfo) navigate(`/dashboard/my_chats`);
    else navigate("/login");
  };

  const handleSwitchToSeller = async () => {
    const customerId = customerInfo?.id;

    try {
      if (customerId) {
        navigate("/");

        const { data } = await api.get(
          `/api/customer/switch-to-seller/${customerId}`,
          { withCredentials: true },
        );

        dispatch(reset_card());
        await dispatch(logout());

        window.location.href = `${data.redirect}?from=customer`;
      } else {
        toast(t("Connecter vous ou créer un compte"));
        navigate("/sell_on_gobymall");
      }
    } catch {
      toast(t("Vous n'avez pas de compte vendeur, veillez créer"));
      navigate("/sell_on_gobymall");
    }
  };

  // 🔥 Charger données utilisateur
  useEffect(() => {
    if (!customerInfo?.id) {
      dispatch(reset_card());
      return;
    }

    const customerId = customerInfo.id;

    dispatch(get_card_products(customerId));
    dispatch(get_wishlists_products(customerId));

    dispatch(
      add_friend({
        sellerId: "",
        customerId,
      }),
    );
  }, [customerInfo?.id, dispatch]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className='w-full bg-white'>
      {card_loading && (
        <div className='fixed inset-0 flex justify-center items-center bg-gray-500/10 z-[99999]'>
          <FadeLoader />
        </div>
      )}

      <HeaderTop
        card_loading={card_loading}
        t={t}
        customerInfo={customerInfo}
        handleLogout={handleLogout}
        handleSwitchToSeller={handleSwitchToSeller}
        changeLanguage={changeLanguage}
        redirect_to_wishlist_page={redirect_to_wishlist_page}
        redirect_to_card_page={redirect_to_card_page}
        redirect_to_chat_page={redirect_to_chat_page}
        wishList_count={wishList_count}
        card_total={card_total}
        totalCustommerUnread={totalCustommerUnread}
      />

      <HeaderMain
        pathname={pathname}
        t={t}
        customerInfo={customerInfo}
        handleLogout={handleLogout}
        handleSwitchToSeller={handleSwitchToSeller}
        redirect_to_wishlist_page={redirect_to_wishlist_page}
        redirect_to_card_page={redirect_to_card_page}
        redirect_to_chat_page={redirect_to_chat_page}
        wishList_count={wishList_count}
        card_total={card_total}
        showSliderbar={showSliderbar}
        setShowSliderbar={setShowSliderbar}
        totalCustommerUnread={totalCustommerUnread}
      />

      <HeaderSidebar
        showSliderbar={showSliderbar}
        setShowSliderbar={setShowSliderbar}
        t={t}
        pathname={pathname}
        customerInfo={customerInfo}
        handleLogout={handleLogout}
        handleSwitchToSeller={handleSwitchToSeller}
        changeLanguage={changeLanguage}
        redirect_to_wishlist_page={redirect_to_wishlist_page}
        redirect_to_card_page={redirect_to_card_page}
        redirect_to_chat_page={redirect_to_chat_page}
        totalCustommerUnread={totalCustommerUnread}
        wishList_count={wishList_count}
        card_total={card_total}
      />

      <div className='w-[95%] lg:w-[90%] mx-auto'>
        <div className='flex flex-wrap md-ld:gap-8 sm:gap-4'>
          <HeaderCategories
            t={t}
            categories={categories}
            categoryShow={categoryShow}
            setCategoryShow={setCategoryShow}
          />

          <HeaderSearchBar
            t={t}
            categories={categories}
            category={category}
            setCategory={setCategory}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            handleSearch={handleSearch}
          />
        </div>
      </div>
    </div>
  );
};

export default Headers;
